import { render, staticRenderFns } from "./BldgList.vue?vue&type=template&id=90df3b0e&scoped=true"
import script from "./BldgList.vue?vue&type=script&lang=js"
export * from "./BldgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90df3b0e",
  null
  
)

export default component.exports